<template>
    <td class="border-b border-gray-200 px-3 py-4 text-sm sm:table-cell">
      <div class="flex justify-center gap-1.5">
        <div v-for="(value, key) in columnData" :key="key" >
          <button
            @click="openModal"
            type="button"
            class="block w-full x-3 py-2 text-center text-sm sm:w-auto"
          >
            <Icon
              class="text-xl"
              name="edit_square"
            />
        </button>
        </div>
      </div>
    </td>

    <ContactFormModal 
      v-if="displayModal"
      @toggleForm="toggleForm"
      :country_codes="country_codes"
      :contact_sources="contact_sources"
      :countries="countries"
      :defaultCountry="defaultCountry"
      :selectedJob="selectedJob"
    />

</template>

<script setup>
  import { provide, inject, ref, watch } from 'vue';
  import { Icon } from '@/components/block/icon';
  import { __ } from '../../../../../helpers';
  import ContactFormModal from '../components/contact-form-modal.vue';

  const selectedJob = inject('selectedJob');
  const country_codes= inject('country_codes');
  const contact_sources= inject('contact_sources');
  const countries= inject('countries');
  const defaultCountry= inject('defaultCountry');

  const loadUsers= inject('loadUsers');
  provide('loadUsers', loadUsers);

  const displayModal = ref(false);

  const props = defineProps({
    candidateIndex: Number,
    columnData: [Object, Array, String, Number],
    person: Object,
    people: Array,
    total: Number
  });

  const form = ref(props.columnData.data);
  provide('form', form);

  function openModal() {
    displayModal.value = true;  
  }

  function toggleForm() {
    displayModal.value = !displayModal.value;
  }
</script>
